module.exports = __webpack_public_path__ + "static/media/success_transaction_image.bf79b3f9.png";